import AxiosConfig from '@/config/axios-config'

export default {

  listarFerramentas () {
    return AxiosConfig.secureJalekoAPI().get('/ferramentas').then(response => response.data)
  },

  listarResumos () {
    return AxiosConfig.secureJalekoAPI().get('/ferramentas/resumos').then(response => response.data)
  },

  listarModelos3D () {
    return AxiosConfig.secureJalekoAPI().get('/ferramentas/modelos-3d').then(response => response.data)
  },

  listarMapasMentais () {
    return AxiosConfig.secureJalekoAPI().get('/ferramentas/mapas-mentais').then(response => response.data)
  },

  listarMaisAcessados (tipo) {
    return AxiosConfig.secureJalekoAPI().get('/ferramentas/mais-acessados?tipo=' + tipo).then(response => response.data)
  }

}
